import { ApiModel } from './models/api.model';

export const API: ApiModel = {
  domains: {
    aus: 'https://beta.workshopsoftware.com.au',
    can: 'https://beta.workshopsoftware.com.au',
    gbr: 'https://beta.workshopsoftware.com.au',
    usa: 'https://beta.workshopsoftware.com.au'
  },
  subdomain: 'beta',
  url      : SERVER_ENDPOINT || '/api'
};
